<template>
  <div
    class="d-flex flex-column "
    data-spy="scroll"
    data-target="#mainNav"
    data-offset="75"
  >
    <navigation-main />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">
              <b-tabs>
                <b-tab active>
                  <template #title>
                    Activation Requests
                    <span class="badge badge-light">{{
                      pendingUserCount
                    }}</span>
                  </template>

                  <table
                    class="table table-striped table-responsive-md btn-table"
                  >
                    <thead>
                      <tr>
                        <th>Username</th>
                        <th>E-Mail</th>
                        <th>Institution</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="user in PendingUserActivation"
                        :key="user.username"
                      >
                        <td>
                          {{ user.username }}
                        </td>
                        <td>
                          {{ user.email }}
                        </td>
                        <td>{{ user.institution }}</td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-primary btn-sm m-0"
                            v-on:click="activateUser(user.userId)"
                          >
                            Activate User
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tab>

                <b-tab>
                  <template #title>
                    Permission Requests
                    <span class="badge badge-light">{{
                      pendingUserRequestsCount + pendingRoleRequestsCount
                    }}</span>
                  </template>
                  <table
                    class="table table-striped table-responsive-md btn-table"
                  >
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Role</th>
                        <th>Reason</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="request in pendingRoleRequests"
                        :key="request._id"
                      >
                        <td>
                          {{ printUserForId(request.userId) }}
                        </td>
                        <td>
                          {{ printRoleName(request.roleId) }}
                        </td>
                        <td>
                          <p
                            v-for="line in request.reason.split('\n')"
                            :key="line"
                          >
                            {{ line }}
                          </p>
                        </td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-primary btn-sm m-0"
                            v-on:click="
                              grantRoleAccess(request.userId, request.roleId)
                            "
                          >
                            Grant Access
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    class="table table-striped table-responsive-md btn-table"
                  >
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Package</th>
                        <th>Reason</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="request in pendingUserRequests"
                        :key="request.username + request.packageName"
                      >
                        <td>
                          {{
                            request.firstname +
                              " " +
                              request.lastname +
                              " (" +
                              request.username +
                              ")"
                          }}
                        </td>
                        <td>
                          {{ request.packageName }}
                        </td>
                        <td>
                          <p
                            v-for="line in request.reason.split('\n')"
                            :key="line"
                          >
                            {{ line }}
                          </p>
                        </td>
                        <td>
                          <button
                            type="button"
                            class="btn btn-primary btn-sm m-0"
                            v-on:click="
                              grantAccess(request.userId, request.packageId)
                            "
                          >
                            Grant Role
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tab>

                <b-tab>
                  <template #title>
                    Packages
                    <span class="badge badge-light"></span>
                  </template>
                  <button class="btn btn-primary" @click="showModal = true">
                    Add New Package
                  </button>
                  <table
                    class="table table-striped table-responsive-md btn-table"
                  >
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Link</th>
                        <th>Size</th>
                        <th>Personal Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="pack in allPackages" :key="pack.packageId">
                        <td>
                          {{ pack.name }}
                        </td>
                        <td>
                          {{ pack.description }}
                        </td>
                        <td>
                          <pre>{{ pack.URI }}</pre>
                        </td>
                        <td>
                          {{ pack.size }}
                        </td>
                        <td>
                          {{ pack.personalData }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tab>
                <b-tab>
                  <template #title>
                    Roles
                  </template>
                  <div id="accordion">
                    <div class="card" v-for="role in roles" :key="role._id">
                      <div class="card-header" id="headingOne">
                        <h5 class="mb-0">
                          <button
                            class="btn btn-link"
                            data-toggle="collapse"
                            :data-target="'#' + role._id"
                            aria-expanded="true"
                            :aria-controls="role._id"
                          >
                            {{ role.name }}
                          </button>
                        </h5>
                      </div>

                      <div
                        :id="role._id"
                        class="collapse show"
                        :aria-labelledby="role._id"
                        data-parent="#accordion"
                      >
                        <div class="card-body">
                          <div class="checkbox">
                            <label
                              v-for="pack in allPackages"
                              :key="pack.packageId"
                              class="checkbox-inline pr-2 pl-1"
                            >
                              <input
                                type="checkbox"
                                class="mr-1"
                                :value="pack.packageId"
                                v-model="role.packages"
                                name="optcheckbox"
                              />{{ pack.name }}
                            </label>
                            <button
                              type="button"
                              class="btn btn-primary btn-sm m-0 float-right"
                              :class="{ disabled: !hasRoleChanged(role) }"
                              v-on:click="submitRole(role)"
                            >
                              <i class="fas fa-save"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    Users
                  </template>

                  <h3></h3>
                  <v-textarea
                    solo
                    lable="Displayed E-Mail Addresses"
                    name="input-7-1"
                    rows="2"
                    row-height="20"
                    :value="getRefs()"
                  ></v-textarea>
                  <v-data-table
                    dense
                    ref="userTable"
                    :headers="userHeaders"
                    :items="allUsers"
                    item-key="name"
                    class="elevation-1"
                    :hide-default-footer="true"
                    disable-pagination
                    style="width:100%"
                  >
                    <template v-slot:body.prepend>
                      <tr>
                        <td>
                          <v-text-field
                            v-model="usertable.firstname"
                            type="text"
                            label="Firstname"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="usertable.lastname"
                            type="text"
                            label="Lastname"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="usertable.username"
                            type="text"
                            label="Username"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="usertable.email"
                            type="text"
                            label="E-Mail"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="usertable.institution"
                            type="text"
                            label="Institution"
                          ></v-text-field>
                        </td>
                        <td>
                          <v-text-field
                            v-model="usertable.roles"
                            type="text"
                            label="Roles"
                          ></v-text-field>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:item.roles="props">
                      <div>
                        <span
                          v-for="role in props.item.roles"
                          :key="role"
                          class="badge p-2 m-1"
                          :class="{
                            'badge-danger': role == 'admin',
                            'badge-primary': role.indexOf('package') == -1,
                            'badge-secondary': role.indexOf('package') != -1
                          }"
                        >
                          {{ getRoleName(role) }}
                          <i
                            @click="removeRole(role, user)"
                            class="btn fas fa-minus p-0 border-0"
                            style="color:white; margin-left: 10px !important; font-size:12px;"
                          ></i>
                        </span>

                        <select
                          @change="onSelectChange($event, user)"
                          class=""
                          style="width:25px;"
                        >
                          <option value="Add Role" disabled selected>+</option>
                          <option
                            v-for="r in rolesOld"
                            :key="r._id"
                            :value="r.name"
                            >{{ r.name }}</option
                          >
                          <option
                            v-for="pack in allPackages"
                            :key="pack.packageId"
                            :value="'package_' + pack.packageId"
                          >
                            {{ pack.name }}
                          </option>
                        </select>
                      </div>
                    </template>
                  </v-data-table>
                </b-tab>

                <b-tab>
                  <template #title>
                    Submissions
                  </template>

                  <AdminPanelSubmissionOverview
                    :userIdCallback="printUserForId"
                  >
                  </AdminPanelSubmissionOverview>
                </b-tab>
              </b-tabs>
            </div>
          </section>
        </div>
      </main>
    </div>
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Add Package</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" @click="showModal = false"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body">
                  <form>
                    <div class="form-group">
                      <label for="i1">Package Name</label>
                      <input
                        type="text"
                        class="form-control"
                        id="i1"
                        v-model="newPackage.name"
                        placeholder="Example Package"
                      />
                    </div>
                    <div class="form-group">
                      <label for="i2">URI</label>
                      <input
                        type="text"
                        class="form-control"
                        id="i2"
                        v-model="newPackage.URI"
                        placeholder="/packages/my_package.zip"
                      />
                    </div>
                    <div class="form-group">
                      <label for="i3">Personal Data</label>
                      <input
                        type="checkbox"
                        class="form-control"
                        id="i3"
                        v-model="newPackage.personalData"
                        placeholder="false"
                      />
                    </div>
                    <div class="form-group">
                      <label for="i4">Download Title</label>
                      <input
                        type="text"
                        class="form-control"
                        id="i4"
                        v-model="newPackage.downloadTitle"
                        placeholder="gt_validation"
                      />
                    </div>

                    <div class="form-group">
                      <label for="i5">Description</label>
                      <textarea
                        class="form-control"
                        id="i5"
                        v-model="newPackage.description"
                        placeholder="Description"
                      >
                      </textarea>
                    </div>

                    <div class="form-group">
                      <label for="i6">Size</label>
                      <input
                        type="text"
                        class="form-control"
                        id="i6"
                        v-model="newPackage.size"
                        placeholder="10 GB"
                      />
                    </div>

                    <div class="form-group">
                      <label for="i8">MD5</label>
                      <input
                        type="text"
                        class="form-control"
                        id="i8"
                        v-model="newPackage.md5"
                        placeholder="6f03354c35f8d6c8cad07382b96a130e"
                      />
                    </div>

                    <div class="form-group">
                      <label for="i7">Thumbnail image (.png)</label>
                      <input
                        type="file"
                        id="i7"
                        ref="file"
                        v-on:change="handleFileUpload()"
                      />
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="showModal = false"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="addPackage"
                  >
                    Add package
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import NavigationMain from "@/views/navigation/navigation-main";
import { mapActions } from "vuex";
import * as axios from "axios";
import AdminPanelSubmissionOverview from "@/views/user_management/AdminPanelSubmissionOverview";

export default {
  name: "AdminPanel",
  components: { AdminPanelSubmissionOverview, NavigationMain },
  data() {
    return {
      userHeaders: [
        {
          text: "Firstname",
          value: "firstname",
          filter: value =>
            !this.usertable.firstname ||
            (value || "")
              .toUpperCase()
              .indexOf(this.usertable.firstname.toUpperCase()) != -1
        },
        {
          text: "Lastname",
          value: "lastname",
          filter: value =>
            !this.usertable.lastname ||
            (value || "")
              .toUpperCase()
              .indexOf(this.usertable.lastname.toUpperCase()) != -1
        },
        {
          text: "Username",
          value: "username",
          filter: value =>
            !this.usertable.username ||
            (value || "")
              .toUpperCase()
              .indexOf(this.usertable.username.toUpperCase()) != -1
        },
        {
          text: "email",
          value: "email",
          filter: value =>
            !this.usertable.email ||
            (value || "")
              .toUpperCase()
              .indexOf(this.usertable.email.toUpperCase()) != -1
        },
        {
          text: "Institution",
          value: "institution",
          filter: value =>
            !this.usertable.institution ||
            (value || "")
              .toUpperCase()
              .indexOf(this.usertable.institution.toUpperCase()) != -1
        },
        {
          text: "Roles",
          value: "roles",
          filter: value =>
            !this.usertable.roles ||
            (value.join(",") || "")
              .toUpperCase()
              .indexOf(this.usertable.roles.toUpperCase()) != -1
        }
      ],
      usertable: {
        firstname: "",
        lastname: "",
        username: "",
        email: "",
        institution: "",
        roles: ""
      },
      showModal: false,
      newPackage: {
        name: "",
        URI: "",
        personalData: false,
        size: "",
        downloadTitle: "",
        description: "",
        md5: ""
      },
      allPackages: [],
      pendingUserRequests: [],
      pendingUserRequestsCount: 0,
      PendingUserActivation: [],
      pendingUserCount: 0,
      rolesOld: [],
      roles: [], // _id, name, packages
      allUsers: [],
      pendingRoleRequests: [],
      pendingRoleRequestsCount: []
    };
  },

  methods: {
    ...mapActions("api", [
      "listPendingRequests",
      "activatePendingRequest",
      "listPendingPackageRequests",
      "grantAccessForPackageRequest",
      "addNewPackage",
      "getAllPackages",
      "getAllRoles",
      "submitRoleChanges",
      "getUsers",
      "addRoleToUser",
      "removeRoleFromUser",
      "grantAccessForRoleRequest"
    ]),
    handleFileUpload() {
      this.newPackage.file = this.$refs.file.files[0];
    },
    listPending() {
      console.log("tionweirnwo");
      this.listPendingRequests().then(data => {
        this.PendingUserActivation = data.pendingRequests;
        this.pendingUserCount = this.PendingUserActivation.length;
      });
    },
    hasRoleChanged(newRole) {
      return !this.rolesOld.find(
        role =>
          role._id == newRole._id &&
          JSON.stringify(role.packages) == JSON.stringify(newRole.packages)
      );
    },
    listRequests() {
      this.listPendingPackageRequests().then(data => {
        console.log(data.packageRequests);
        this.pendingUserRequests = data.packageRequests;
        this.pendingUserRequestsCount = data.packageRequests.length;
        this.pendingRoleRequests = data.roleRequests;
        this.pendingRoleRequestsCount = data.roleRequests.length;
      });
    },
    activateUser(userId) {
      this.activatePendingRequest({ userId })
        .then(() => {
          const removeIndex = this.PendingUserActivation.map(
            user => user.userId
          ).indexOf(userId);
          if (removeIndex == -1) {
            console.log("index was -1");
          } else {
            this.PendingUserActivation.splice(removeIndex, 1);
          }
        })
        .catch(err => console.log(err));
    },
    grantAccess(userId, packageId) {
      this.grantAccessForPackageRequest({ userId, packageId })
        .then(() => this.listRequests())
        .catch(err => alert(err));
    },
    grantRoleAccess(userId, roleId) {
      this.grantAccessForRoleRequest({ userId, roleId })
        .then(() => this.listRequests())
        .catch(err => alert(err));
    },
    addPackage() {
      this.addNewPackage({ newPackage: this.newPackage }).then(() => {
        this.showModal = false;
        this.getPackages();
      });
    },
    getPackages() {
      this.getAllPackages().then(list => {
        console.log(list.packages);
        this.allPackages = list.packages.map(p => {
          p.packageId = p._id;
          return p;
        });
      });
    },
    getRoles() {
      this.getAllRoles().then(data => {
        console.log(data);
        this.roles = data.roles;
        this.rolesOld = JSON.parse(JSON.stringify(this.roles));
      });
    },
    submitRole(newRole) {
      this.submitRoleChanges(newRole).then(this.getRoles());
    },
    getRoleName(role) {
      if (role.indexOf("package_") != -1) {
        // Pseudo role for package
        const packageId = role.replace("package_", "");
        const pack = this.allPackages.find(pack => pack.packageId == packageId);
        if (pack) {
          return pack.name;
        }
      }
      return role;
    },
    getAllUsers() {
      this.getUsers().then(
        data =>
          (this.allUsers = data.users
            .map(entry => {
              entry.roles.sort();
              return entry;
            })
            .sort((e1, e2) => e1.roles[0] > e2.roles[0]))
      );
    },
    getRefs() {
      return this.$refs.userTable?._data.internalCurrentItems
        .map(item => item.email)
        .join(";");
    },
    onSelectChange(event, user) {
      const newRoleToAdd = event.target.value;
      if (newRoleToAdd == "Add Role") {
        return;
      }

      const userId = user.userId;
      this.addRoleToUser({ id: userId, role: newRoleToAdd }).then(() =>
        this.getAllUsers()
      );
      event.target.value = "Add Role";
    },
    removeRole(role, user) {
      this.removeRoleFromUser({ id: user.userId, role: role }).then(() =>
        this.getAllUsers()
      );
    },
    printUserForId(userId) {
      const user = this.allUsers.filter(user => user.userId == userId)[0];
      return user.firstname + " " + user.lastname + " (" + user.username + ")";
    },
    printRoleName(roleId) {
      return this.roles.filter(role => role._id == roleId)[0]?.name;
    }
  },
  created() {
    this.listPending();
    this.listRequests();
    this.getPackages();
    this.getRoles();
    this.getAllUsers();
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
